import { useState } from "react";
import { Copy, Check } from "lucide-react";

type Props = {
  docId: string;
  title: string;
  version?: string | number | null;
  updatedAt?: string | null;
  collection: "faq" | "sop";
  slug?: string | null;
};

function formatDate(iso?: string | null): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  return d.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
}

export function DocMetaFooter({ docId, title, version, updatedAt, collection, slug }: Props) {
  const [copied, setCopied] = useState(false);
  const updated = formatDate(updatedAt);

  const handleCopy = async () => {
    let url = typeof window !== "undefined" ? window.location.href.split("#")[0] : "";
    if (typeof window !== "undefined" && slug) {
      const seg = docId === "FAQ-000" ? "dictionary" : slug;
      url = `${window.location.origin}/support/library/${seg}`;
    }
    const text = `${title} ${url}`.trim();
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* ignore */
    }
  };

  const meta = [
    docId || null,
    version != null ? `Version ${version}` : null,
    updated ? `Updated ${updated}` : null,
  ].filter(Boolean);


  return (
    <div className="mt-3 text-right text-xs text-muted-foreground flex items-center justify-end gap-2">
      <span>{meta.join(" · ")}</span>

      <button
        type="button"
        onClick={handleCopy}
        aria-label="Copy link with reference"
        title={copied ? "Copied" : "Copy link with reference"}
        className="inline-flex items-center opacity-80 hover:opacity-100 transition-opacity"
      >
        {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
      </button>
    </div>
  );
}
